import styled from 'styled-components';

import { Caption } from '@/components/Typography/Typography';

type TagType = 'primary' | 'dark' | 'transparent';
type TagProps = {
  type?: TagType;
};
const handleType = (type?: TagType): { bg: string; color: string } => {
  switch (type) {
    case 'dark':
      return { bg: '--color-black', color: '--color-white' };
    case 'primary':
      return { bg: '--color-primary', color: '--color-white' };
    case 'transparent':
      return { bg: '--color-transparent', color: '--color-mine-shaft' };
    default:
      return { bg: '--color-alto', color: '--color-black' };
  }
};

export const Tag = styled(Caption).attrs((props) => ({ as: 'span', ...props }))<TagProps>`
  background-color: var(${({ type }) => handleType(type).bg});
  border-radius: var(--radius-inner);
  color: var(${({ type }) => handleType(type).color});
  display: inline-block;
  padding: 0 var(--gap-xxs);
  white-space: nowrap;
`;

export const TagHanging = styled(Tag)<{ primary?: boolean; dark?: boolean; right?: boolean; largeSpacingRight?: boolean }>`
  background-color: var(
    ${({ dark, primary }) => {
      if (primary) {
        return '--color-primary';
      } else if (dark) {
        return '--color-black';
      }
      return '--color-secondary';
    }}
  );
  border-radius: 0 0 var(--radius-inner) var(--radius-inner);
  color: var(${({ dark, primary }) => (dark || primary ? '--color-white' : '--color-black')});
  position: absolute;
  top: 0;
  z-index: 20;
  ${({ right, largeSpacingRight }) => `${right ? 'right' : 'left'}: var(${largeSpacingRight ? '--gap-lg' : '--gap-sm'});`}
`;

export const SidebarTag = styled(Caption)`
  color: var(--color-dove-gray);
`;
